import ServiceDetailPage from "./ServiceDetailPage";
import serviceContent from "./serviceContent";

const UXStrategy = () => <ServiceDetailPage service={serviceContent.uxStrategy} />;

export default UXStrategy;
